import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonGroup } from '@atlaskit/button';
import TextField from '@atlaskit/textfield';
import { PrimaryCTA } from '@atlassian/amkt-common';
import React, { Component } from 'react';
import { ANALYTICS_MODAL_UNINSTALL_SITE } from '../../../../../../analytics/Sources';
import { resolveFieldWithFallback } from '../../../../../../utils/common-utils';
import BannerAndIcon from '../../../../../common/BannerAndIcon';
import ModalDialog from '../../../../../common/ModalDialog';
import SecondaryCTA from '../../../../../common/SecondaryCTA';
export default class SitewideAppUninstallDialog extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      canUninstall: false
    });
    _defineProperty(this, "updateCanInstall", e => {
      this.setState({
        canUninstall: e.currentTarget.value === this.resolveName()
      });
    });
    _defineProperty(this, "uninstallAppFromSite", () => {
      this.props.uninstallAppFromSite({
        installedApp: this.props.installedApp,
        hostConfig: this.props.hostConfig,
        context: this.props.context
      });
    });
    _defineProperty(this, "onCloseDialog", () => {
      if (!this.props.installedApp.uninstallInProgress) {
        this.props.closeSiteUninstallDialog({
          installedApp: this.props.installedApp
        });
      }
    });
    _defineProperty(this, "renderUninstallConfirmationFooter", () => /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(PrimaryCTA, {
      isLoading: this.props.installedApp.uninstallInProgress,
      appearance: "danger",
      isDisabled: !this.state.canUninstall,
      onClick: this.uninstallAppFromSite
    }, "Remove app"), /*#__PURE__*/React.createElement(SecondaryCTA, {
      appearance: "subtle-link",
      isDisabled: this.props.installedApp.uninstallInProgress,
      onClick: this.onCloseDialog
    }, "Cancel")));
    _defineProperty(this, "resolveName", () => resolveFieldWithFallback(add => add.name, this.props.installedApp.marketplaceAppDetails, this.props.installedApp.details));
  }
  render() {
    const appName = this.resolveName();
    return /*#__PURE__*/React.createElement(ModalDialog, {
      analyticsName: ANALYTICS_MODAL_UNINSTALL_SITE,
      width: "medium",
      onClose: this.onCloseDialog,
      heading: this.props.hostConfig.removeFromSite.actionSummary(appName),
      footer: this.renderUninstallConfirmationFooter()
    }, /*#__PURE__*/React.createElement(BannerAndIcon, {
      icon: "error"
    }, this.props.hostConfig.removeFromSite.confirmation(appName)), /*#__PURE__*/React.createElement(TextField, {
      autoFocus: true,
      isDisabled: this.props.installedApp.uninstallInProgress,
      label: "To permanently remove this app, type: ".concat(appName),
      onChange: this.updateCanInstall,
      value: ""
    }));
  }
}